import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { ContextualMenuItem } from "../../home/models/OtherTypes";
import { ProductAccessoryService } from "../../products/services/ProductAccessoryService";

export default function useBrandVM() {
    const service = new ProductAccessoryService();

    const [list, setList] = useState<ContextualMenuItem[]>([]);

    const getList = () => {
        const request = service.getShoppingByMenu();
        DataUtils.onRequest(request, onResult);
    }

    const onResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success) {
            const menu = result.data as ContextualMenuItem[];

            if (menu) {
                const brand = menu.find((item) => item.key === "Brands");
                if (brand && brand.subMenuProps) {
                    setList(brand.subMenuProps.items);
                }
            }
        }
    }

    return {
        list, getList
    }
}